"use client";

import { c as _c } from "react/compiler-runtime";
import Hero from "@/widgets/inquiry-landing/ui/organisms/Hero";
import Problem from "@/widgets/inquiry-landing/ui/organisms/Problem";
import Benefits from "@/widgets/inquiry-landing/ui/organisms/Benefits";
import Pricing from "@/widgets/inquiry-landing/ui/organisms/Pricing";
import ApplyCta from "@/widgets/inquiry-landing/ui/organisms/ApplyCta";
import Investors from "@/widgets/inquiry-landing/ui/organisms/Investors";
import Recognized from "@/widgets/inquiry-landing/ui/organisms/Recognized";
import Footer from "@/widgets/inquiry-landing/ui/organisms/Footer";

/**
 * 모든 CTA(`무료 상담 신청하기`, `시작하기` 등)에서 재사용하는 스무스 스크롤 헬퍼.
 * 사용 예: `<button onClick={() => scrollToApply()}>무료 상담 신청하기</button>`
 * 또는 `<a href="#apply">` 도 동일하게 동작.
 */
export const scrollToApply = () => {
  if (typeof document === "undefined") return;
  document.getElementById("apply")?.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
};
const InquiryLandingTemplate = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full bg-white"><Hero /><Problem /><Benefits /><Pricing /><ApplyCta /><Investors /><Recognized /><Footer /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default InquiryLandingTemplate;